// src/store.js
import { configureStore } from "@reduxjs/toolkit";
import navigationReducer from "./navigationSlice";
import pageHeaderReducer from "./pageHeaderSlice";
import showFieldsReducer from "./showFieldsSlice";
import relatedFieldsReducer from "./relatedFieldsSlice";
import navPopupReducer from "./navPopupSlice";
import savePopupReducer from "./savePopupSlice";
import authenticationReducer from "./authenticationSlice";
import processQueueReducer from "./processQueueSlice";

const store = configureStore({
  reducer: {
    navigation: navigationReducer,
    pageHeader: pageHeaderReducer,
    showFields: showFieldsReducer,
    relatedFields: relatedFieldsReducer,
    navPopup: navPopupReducer,
    authentication: authenticationReducer,
    processQueue: processQueueReducer,
    savePopup: savePopupReducer,
    // ...other reducers if needed
  },
});

export default store;
